// extracted by mini-css-extract-plugin
export default {"user":"style_user__uPCUS","edit":"style_edit__B3ZLF","delete":"style_delete__7gOCa","table_container":"style_table_container__9B-rC","userImage":"style_userImage__NA2wL"};